import { JSX } from 'react';

import {
  ICustomRenderCellJSXProps,
  IListViewTableColumns,
  IListViewTablePagination,
  Order,
  RowsPerPage,
} from '~/src/dash/components/tables/ListViewTable/common';
import { spacing } from '~/src/dash/publicaUI';
import {
  InventoryRulesModalLink,
  NameWithDefault,
} from '~/src/dash/views/inventory-rules-v2/common';

export interface IAdBreaksListConfig {
  cypressClassName: string;
  defaultState: {
    activeColumnKeys: string[];
    orderDirection: Order;
    orderBy: TAdBreaksListKey;
    page: number;
    rowsPerPage: RowsPerPage;
  };
  timezone: string;
  columns: IListViewTableColumns;
  table: IListViewTablePagination;
  activeColumnKeys: string[];
}

export const adBreaksListConfig: IAdBreaksListConfig = {
  cypressClassName: 'ad-breaks-list',
  defaultState: {
    activeColumnKeys: ['AssociatedInventoryRules', 'AdBreaks'],
    orderDirection: 'desc',
    orderBy: 'ID',
    page: 0,
    rowsPerPage: 25,
  },
  timezone: 'UTC',
  activeColumnKeys: ['AssociatedInventoryRules', 'AdBreaks'],
  columns: {
    ID: {
      formatValue: (value: number) => value.toString(),
      isHidden: true,
      isSearchable: false,
      key: 'ID',
      label: 'ID',
      requestKey: 'ID',
      responseKey: 'ID',
      valueType: 'string',
    },
    Name: {
      cellJSX: (props: ICustomRenderCellJSXProps): JSX.Element =>
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        NameWithDefault({ ...props, fallbackName: 'UnnamedAdBreak' }),
      cellRenderType: 'name',
      defaultOrderDirection: 'asc',
      headerRenderType: 'name',
      headerStyle: {
        width: '25%',
      },
      cellStyle: {
        width: '25%',
      },
      isSearchable: true,
      key: 'Name',
      label: 'Name',
      tKey: 'Name',
      requestKey: 'Name',
      responseKey: 'Name',
      valueType: 'string',
      orderByKey: 'Name',
    },
    AssociatedInventoryRules: {
      cellJSX: InventoryRulesModalLink,
      headerRenderType: 'number',
      cellRenderType: 'number',
      headerStyle: {
        textAlign: 'left',
        width: '30%',
        paddingLeft: spacing.none,
      },
      cellStyle: {
        textAlign: 'left',
        width: '30%',
        paddingLeft: spacing.none,
      },
      key: 'AssociatedInventoryRules',
      label: 'Associated Inventory Rules',
      requestKey: 'AssociatedInventoryRules',
      responseKey: 'AssociatedInventoryRules',
      valueType: 'number',
    },
    AdBreaks: {
      headerRenderType: 'string',
      cellRenderType: 'string',
      key: 'AdBreaks',
      tKey: 'AdBreaks',
      label: 'Ad Breaks',
      requestKey: 'AdBreaks',
      responseKey: 'AdBreaks',
      valueType: 'string',
      orderByKey: 'AdBreaks',
    },
  },
  table: {
    order: 'desc',
    orderBy: 'ID',
    page: 0,
    rowsPerPage: 25,
  },
} as unknown as IAdBreaksListConfig;

export type TAdBreaksListKey = keyof typeof adBreaksListConfig.columns;
